// extracted by mini-css-extract-plugin
export default {"trigger":"styles_trigger__sSeCe","dropdownContainer":"styles_dropdownContainer__Ra4bX"};